import './StoresListPage.scss';
import { StoresList } from '../../components/StoresList/StoresList';
import { getStores } from '../../services/storesList';
import { useEffect, useState } from 'react';
import { Store } from '../../types/Store';

export const StoresListPage = () => {
  const [stores, setStores] = useState<Store[]>([]);

  useEffect(() => {	
      fetchStores();
  }, []);

  const fetchStores = async () => {
    try {
      const response = await getStores();
      console.log(response.data)
	  const all_stores = response.data || [];
	  const account_store_ids :string[] = [];
	  const visible_stores = all_stores.filter(store => account_store_ids.includes(store.id || ""));
	  
      if (response.data&&visible_stores) {
        setStores(response.data);
      } 
	  else if(response.data){
        alert('No stores are visible');
      }
	  else{
		alert('Failed to fetch stores');
	  }
    } catch (error) {
      console.error('Error fetching stores:', error);
      alert("Failed to fetch stores. Please check console for details.");
    }
  };

  const handleStoreAdded = () => {
    fetchStores(); // Refresh stores list after adding a store
  };

  return (
    <div className="storesPage">
      <StoresList stores={stores} onStoreAdded={handleStoreAdded} />
    </div>
  );
};
